const questionartData = {
  title: "营销数字化研讨会",
  items: [
    {
      fieldType: "TEXT",
      fieldLevel: "4",
      itemId: "9",
      question: "姓名",
      ruleId: "",
      fieldName: "姓名",
      regularExpression: "",
      isCommon: "0",
      type: "4",
      key: "",
      necessary: "1",
      answer: "",
      totalScore: "0",
      leadsGrade: "0",
      leadsGradeTitle: "",
      enableRegular: "0",
      selectOptionLimit: "",
    },
    {
      fieldType: "TEXT",
      fieldLevel: "4",
      itemId: "9",
      question: "公司",
      ruleId: "",
      fieldName: "公司",
      regularExpression: "",
      isCommon: "0",
      type: "4",
      key: "",
      necessary: "1",
      answer: "",
      totalScore: "0",
      leadsGrade: "0",
      leadsGradeTitle: "",
      enableRegular: "0",
      selectOptionLimit: "",
    },
    {
      fieldType: "TEXT",
      fieldLevel: "4",
      itemId: "9",
      question: "手机号",
      ruleId: "",
      fieldName: "手机号",
      regularExpression: "",
      isCommon: "0",
      type: "4",
      key: "",
      necessary: "1",
      answer: "",
      totalScore: "0",
      leadsGrade: "0",
      leadsGradeTitle: "",
      enableRegular: "0",
      selectOptionLimit: "",
    },
    {
      fieldType: "TEXT",
      fieldLevel: "4",
      itemId: "9",
      question: "邮箱",
      ruleId: "",
      fieldName: "邮箱",
      regularExpression: "",
      isCommon: "0",
      type: "4",
      key: "",
      necessary: "1",
      answer: "",
      totalScore: "0",
      leadsGrade: "0",
      leadsGradeTitle: "",
      enableRegular: "0",
      selectOptionLimit: "",
    },
    {
      fieldType: "LIST",
      fieldLevel: "4",
      itemId: "11",
      question: "\u5355\u9009\u6309\u94ae",
      ruleId: "",
      fieldName: "\u6587\u672c\u7c7b\u9898\u76ee",
      regularExpression: "",
      isCommon: "0",
      type: "1",
      key: "",
      necessary: "1",
      answer: "",
      totalScore: "0",
      leadsGrade: "0",
      leadsGradeTitle: "",
      enableRegular: "0",
      selectOptionLimit: "",
      options: [
        {
          optionRuleId: "optionRuleId01",
          optionId: "16315142826380",
          title: "\u5355\u9009\u6309\u94ae1",
          picMapId: "",
          picUrl: "//cdn.smarket.net.cn/images/img-pic-default.gif",
          isFillIn: "0",
          isOther: "0",
          text: "",
          score: "0",
          scoreTitle: "\u4e0d\u5f97\u5206",
          $$hashKey: "object:969",
          focus: "0",
        },
        {
          optionRuleId: "optionRuleId11",
          optionId: "16315142826381",
          title: "\u5355\u9009\u6309\u94ae2",
          picMapId: "",
          picUrl: "//cdn.smarket.net.cn/images/img-pic-default.gif",
          isFillIn: "0",
          isOther: "0",
          text: "",
          score: "0",
          scoreTitle: "\u4e0d\u5f97\u5206",
          focus: "0",
          $$hashKey: "object:970",
        },
        {
          optionId: "16316992923882",
          optionRuleId: "optionRuleId2",
          focus: "0",
          title: "\u5176\u4ed6",
          picMapId: "",
          picUrl: "",
          isFillIn: "1",
          isOther: "1",
          text: "",
          score: "0",
          scoreTitle: "\u4e0d\u5f97\u5206",
          $$hashKey: "object:965",
          isFillInRequire: "1",
        },
      ],
    },
    {
      fieldType: "LIST",
      fieldLevel: "4",
      itemId: "12",
      question: "\u591a\u9009\u6309\u94ae",
      ruleId: "",
      fieldName: "\u591a\u9009\u6846",
      regularExpression: "",
      isCommon: "0",
      type: "2",
      key: "",
      necessary: "1",
      answer: "",
      totalScore: "0",
      leadsGrade: "0",
      leadsGradeTitle: "",
      enableRegular: "0",
      selectOptionLimit: "",
      options: [
        {
          optionRuleId: "optionRuleId01",
          optionId: "16315143646780",
          title: "\u591a\u9009\u6309\u94ae1",
          picMapId: "",
          picUrl: "//cdn.smarket.net.cn/images/img-pic-default.gif",
          isFillIn: "0",
          isOther: "0",
          text: "",
          score: "0",
          scoreTitle: "\u4e0d\u5f97\u5206",
          $$hashKey: "object:994",
          focus: "0",
        },
        {
          optionRuleId: "optionRuleId11",
          optionId: "16315143646781",
          title: "\u591a\u9009\u6309\u94ae2",
          picMapId: "",
          picUrl: "//cdn.smarket.net.cn/images/img-pic-default.gif",
          isFillIn: "0",
          isOther: "0",
          text: "",
          score: "0",
          scoreTitle: "\u4e0d\u5f97\u5206",
          focus: "0",
          $$hashKey: "object:995",
        },
        {
          optionId: "16315143464950",
          optionRuleId: "optionRuleId0",
          focus: "0",
          title: "\u5176\u4ed6",
          picMapId: "",
          picUrl: "",
          isFillIn: "1",
          isOther: "1",
          text: "",
          score: "0",
          scoreTitle: "\u4e0d\u6b63\u786e",
          $$hashKey: "object:989",
          isFillInRequire: "1",
        },
      ],
    },
  ],
};
const resultData = {
  questionInfo: {
    id: "2108272722490489",
    title: "\u8bd5\u5377",
    identity: "1",
    type: "3",
    questionBankId: "0",
    tenantId: "54",
    moduleType: "0",
    instanceId: "0",
  },
  getScore: 50,
  totalScore: 100,
  items: [
    {
      id: "21667",
      tenantId: "54",
      moduleId: "0",
      instanceId: "0",
      moduleId2: "8",
      instanceId2: "5280",
      fieldName: "name",
      extendFieldId: "35804",
      displayName: "\u59d3\u540d",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "UNCHECK",
      textRegularExpression: "",
      textLength: "",
      textRegularId: "0",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      deleted: "0",
      isSystemed: "1",
      required: "0",
      errorMessage: "",
      displayType: "1",
      isLogin: "0",
      isFormed: "1",
      extraConfig: "",
      saveFieldName: "tool_questionnaire_extra_text.f_1",
      fieldLevel: "1",
      isSendSms: "0",
      otherOption: "-1",
      otherIsRequire: "-1",
      otherIsFillIn: "-1",
      selectOptionLimit: "0",
      isSensitive: "0",
      privacyPolicyGloble: "",
      privacyPolicyUrl: "",
      privacyPolicyTitle: "",
      privacyPolicyUrlTitle: "",
      isSelected: "",
      privacyPolicyCustomUrl: "",
      canEditFields: [
        "textLimitType",
        "textRegularExpression",
        "textDefaultRegType",
        "textLength",
        "errorMessage",
        "textRegularId",
        "required",
        "textLimitType",
        "textLength",
        "textRegularExpression",
        "errorMessage",
      ],
      status: "0",
      customerDisplayName: "\u59d3\u540d",
      itemId: "1",
      value: "gph",
    },
    {
      id: "21668",
      tenantId: "54",
      moduleId: "0",
      instanceId: "0",
      moduleId2: "8",
      instanceId2: "5280",
      fieldName: "mobile",
      extendFieldId: "35805",
      displayName: "\u624b\u673a",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "SYSTEM",
      textRegularExpression: "^(?!(0|86))\\d+$",
      textLength: "11",
      textRegularId: "17",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      deleted: "0",
      isSystemed: "1",
      required: "0",
      errorMessage: "",
      displayType: "1",
      isLogin: "1",
      isFormed: "1",
      extraConfig: "",
      saveFieldName: "tool_questionnaire_extra_text.f_2",
      fieldLevel: "1",
      isSendSms: "0",
      otherOption: "-1",
      otherIsRequire: "-1",
      otherIsFillIn: "-1",
      selectOptionLimit: "0",
      isSensitive: "1",
      privacyPolicyGloble: "",
      privacyPolicyUrl: "",
      privacyPolicyTitle: "",
      privacyPolicyUrlTitle: "",
      isSelected: "",
      regularExpression: "^(?!(0|86))\\d+$",
      privacyPolicyCustomUrl: "",
      canEditFields: [
        "textLength",
        "errorMessage",
        "required",
        "isSendSms",
        "textLength",
        "errorMessage",
      ],
      status: "0",
      schemaTextLength: "11",
      customerDisplayName: "\u624b\u673a",
      itemId: "2",
      value: "18210767269",
    },
    {
      title: "\u5929\u6c14",
      type: "4",
      score: 10,
      isCorrect: 0,
      answers: "\u6674\u6717",
      answer: "\u6674\u6717",
    },
    {
      title: "\u5355\u9009",
      type: "5",
      score: 40,
      isCorrect: 0,
      optionsContent: [
        {
          id: 1,
          name: "\u5355\u90091",
          optionId: "16318491197080",
          selected: 1,
          isSelect: 0,
        },
        {
          id: 2,
          name: "\u5355\u90092",
          optionId: "16318491197081",
          selected: 0,
          isSelect: 1,
        },
      ],
      answers: "16318491197080",
      answer: "",
    },
    {
      title: "\u591a\u9009",
      type: "2",
      score: 50,
      isCorrect: 1,
      optionsContent: [
        {
          id: 1,
          name: "\u591a\u90091",
          optionId: "16318491344830",
          selected: 1,
          isSelect: 1,
        },
        {
          id: 2,
          name: "\u591a\u90092",
          optionId: "16318491344831",
          selected: 1,
          isSelect: 1,
        },
      ],
      answers: "16318491344830,16318491344831",
      answer: "",
    },
  ],
  name: "\u8bd5\u5377",
};
export { questionartData, resultData };
